import cx from 'classnames';
import Button from 'govbr.frontend.policy/components/Button';
import PropTypes from 'prop-types';

const filterValidButtons = (buttons, isEditMode) =>
  buttons.filter((button) => {
    const { label, href, isCircle, icon } = button;
    const hasLink = href?.[0];
    const hasBasicAttributes = label && hasLink;
    const hasCircleAttributes = label && icon && hasLink;
    const isMissingRequiredAttributes = isCircle
      ? !hasCircleAttributes
      : !hasBasicAttributes;

    if (!isEditMode && isMissingRequiredAttributes) {
      return null;
    }
    return true;
  });

const GroupButtonBody = ({ data, isEditMode = false }) => {
  const { buttons = [], align } = data || {};
  const filterButtons = filterValidButtons(buttons, isEditMode);
  const classesContainer = cx('mb-4', `text-${align}`);
  if (filterButtons.length === 0) return null;

  return (
    <div className={classesContainer}>
      {filterButtons.map((button, index) => {
        const {
          '@id': id,
          href,
          size = 'default',
          type = 'secondary',
          isCircle,
          inverted,
          icon,
          label,
        } = button;

        const hasLink = href?.[0];
        const nextButton = filterButtons[index + 1];
        const className = cx(
          { 'mb-2': filterButtons.length > 1 },
          { 'mr-sm-3': index < filterButtons.length - 1 },
          { 'mr-3': isCircle && nextButton && nextButton.isCircle },
        );
        return (
          <Button
            key={id}
            label={label}
            link={hasLink?.['@id']}
            variant={type}
            size={size}
            isCircle={isCircle}
            inverted={inverted}
            icon={icon}
            isEditMode={isEditMode}
            className={className}
          />
        );
      })}
    </div>
  );
};

GroupButtonBody.propTypes = {
  data: PropTypes.shape({
    buttons: PropTypes.arrayOf(PropTypes.object),
    align: PropTypes.string,
  }),
  isEditMode: PropTypes.bool,
};

export default GroupButtonBody;
